import { render, staticRenderFns } from "./WorkflowEmpty.vue?vue&type=template&id=293dfd5b&"
import script from "./WorkflowEmpty.vue?vue&type=script&lang=js&"
export * from "./WorkflowEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports